import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option"]

  connect() {
    // Enable/disable continue button based on initial selection
    this.updateContinueButton()
  }

  handleSelection(event) {
    // Update continue button when selection changes
    this.updateContinueButton()
  }

  updateContinueButton() {
    const radioButtons = document.querySelectorAll('input[name="selected_business_type"]')
    const continueBtn = document.getElementById('continue-btn')
    const selectedBusinessTypeInput = document.querySelector('form input[name="selected_business_type"][type="hidden"]')
    
    const selectedRadio = Array.from(radioButtons).find(radio => radio.checked)
    const isSelected = selectedRadio !== undefined
    
    // Enable/disable the continue button
    if (continueBtn) {
      continueBtn.disabled = !isSelected
    }
    
    // Update the hidden field in the continue form
    if (selectedRadio && selectedBusinessTypeInput) {
      selectedBusinessTypeInput.value = selectedRadio.value
    }
  }
}
